import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'floatCalculate',
    standalone: false
})
export class FloatCalculatePipe implements PipeTransform {
  transform(converObj: any): string {
    if (converObj) {
      const floatValue = parseFloat(converObj.value).toFixed(converObj.float);
      return floatValue;
    }
  }
}

@Pipe({
    name: 'floatCalcFixDecimal',
    standalone: false
})
export class FloatCalcFixDecimalPipe implements PipeTransform {
  transform(_value: any, floatPosition: number, roundValue: boolean): string {
    if (_value && this.isFloat(_value)) {
      let floatValue;
      if (roundValue) {
        const decimalValue = parseFloat(_value).toFixed(0);
        floatValue = decimalValue.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
      } else {
        floatValue = parseFloat(_value).toFixed(floatPosition);
      }
      return floatValue;
    } else {
      return _value;
    }
  }

  isFloat(v) {
    return !!(v % 1);
  }
}
